export const PWA_HIDDEN_ROUTES: Set<string> = new Set(["/", "/terms", "/privacy"])
